import React from 'react'
import {
  Col,
  Row
} from 'reactstrap'

import ResearchCategoriesCard from '../../molecules/ResearchCategoriesCard'
import ResearchProductsCard from '../../molecules/ResearchProductsCard'
import ResearchMeasurementUnitsCard from '../../molecules/ResearchMeasurementUnitsCard'

export default class ResearchCards extends React.PureComponent {
  render() {
    return (
      <div>
        <Row>
          <Col xs="4">
            <ResearchCategoriesCard
              { ...this.props.categoriesCardProps }
            />
          </Col>
          <Col xs="4">
            <ResearchProductsCard
              { ...this.props.productsCardProps }
            />
          </Col>
          <Col xs="4">
            <ResearchMeasurementUnitsCard
              { ...this.props.measurementUnitsCardProps }
            />
          </Col>
        </Row>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/organisms/ResearchCards/ResearchCards.js